// @ts-nocheck
import {
    createHandlerChainRunnerOptionalParameter,
    HandlerWithResult,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import { Cart, updateCart, updateCartWithResult } from "@insite/client-framework/Services/CartService";
import {
    UpdateCartLineApiParameter,
    updateCartLineWithResult as updateCartLineApi,
} from "@insite/client-framework/Services/CartService";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import loadCurrentCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import { CartModel } from "@insite/client-framework/Types/ApiModels";
import cloneDeep from "lodash/cloneDeep";

type HandlerType = HandlerWithResult<HasOnSuccess<Cart>, Cart, { cartToUpdate: CartModel }>;

export const DispatchBeginUpdatingCart: HandlerType = props => {
    props.dispatch({
        type: "Context/BeginUpdatingCart",
    });
};

export const SetCartStatus: HandlerType = props => {
    const state = props.getState();
    const cart = getCurrentCartState(state).value;

    if (!cart) {
        throw new Error("There was no current cart");
    }

    const cartCopy = cloneDeep(cart);

    cartCopy.cartLines?.forEach(async line => {
        if (line.properties.whsePickType) {
            line.properties.whsePickType = "";
            await updateCartLineApi({ cartId: cart.id, cartLine: line });
        }
    });

    props.cartToUpdate = {
        ...cartCopy,
    };
};

export const UpdateCart: HandlerType = async props => {
    props.result = (await updateCart({ cart: props.cartToUpdate })).cart;
};

export const DispatchCompleteUpdatingCart: HandlerType = props => {
    props.dispatch({
        type: "Context/CompleteUpdatingCart",
    });
};

export const LoadCart: HandlerType = props => {
    props.dispatch(loadCurrentCart());
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    props.parameter.onSuccess?.(props.result);
};

export const chain = [
    DispatchBeginUpdatingCart,
    SetCartStatus,
    UpdateCart,
    DispatchCompleteUpdatingCart,
    LoadCart,
    ExecuteOnSuccessCallback,
];

const removeCartLineSelectedWhsePickType = createHandlerChainRunnerOptionalParameter(
    chain,
    {},
    "RemoveCartLineSelectedWhsePickType",
);
export default removeCartLineSelectedWhsePickType;
